import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/style.css';
import '../css/login1.css';
import "react-custom-flag-select/lib/react-custom-flag-select.min.css";
import OtpInput from 'react-otp-input';
import {subApi,unsubApi} from '../../services/user-api';
import {serviceId,Loader,countryCode,flag,Popup,PopupSub} from "../../utils/constant";

const Ecoz = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [popupLoader, setPopupLoader] = useState(false);
    const [flowLoading, setFlowLoading] = useState(false); 
    const [subMsg, setSubMsg] = useState('');   
    const [flow, setFlow] = useState('');   
    const [phone, setPhone] = useState(localStorage.getItem("ugAlias"));
    const [subOption, setSubOption] = useState(1);
    const [plan, setPlan] = useState(1);
    const [price, setPrice] = useState(["0","2.02 ZWG/Day","8.08 ZWG/Week","24.25 ZWG/Month"]);
    const [message, setMessage] = useState({message: "",error: false});
    const [otpId, setOtpId] = useState('');
    const [otp, setOtp] = useState('');
    const [isActive, setIsActive] = useState(false);
    const [seconds, setSeconds] = useState(0);
    const [subStatus, setSubStatus] = useState(0);
    const [popup, setPopup] = useState(false);
    const [ButtonDisabled, setButtonDisabled] = useState(true);  
    const [ButtonLoginDisabled, setButtonLoginDisabled] = useState(true); 
    const msgInprocess="Your subscription request is received.It will process soon and confirm you via sms";
    const msgLowbalance="You have insufficient balance. Please recharge your number and try again to access this service.";
 
    useEffect(() => {
        let timer = null;
        if(isActive){
            setSeconds(0);
            timer = setInterval(() => {
                setSeconds((seconds) =>{ 
                    if(seconds<60) return seconds + 1;
                    else 
                    {
                        clearInterval(timer);
                        setIsActive(false);
                        return seconds;
                    }

                });
            }, 1000);
        }
        return () => {
            clearInterval(timer);
         }; 
    }, [isActive]); 

    useEffect(() => {
       var nm=0;    
       if(phone) 
        {   
            setButtonDisabled(false);
            nm=phone;if(nm.length<=10)nm=countryCode+nm
            if(phone.length>9)setPhone(phone.substring(3,phone.length));
        }
        const token = localStorage.getItem('token');
        if (!token)setFlow("");
        else 
        {
            setFlow("PACK");
            setFlowLoading(true); 
            subApi({action:0,ani: nm,serviceId:serviceId}).then((res) => {
                setFlowLoading(false);
                if(res.data.data!==null && res.data.data!==undefined)
                {
                    if(res.data.status===1 || res.data.status===2){setPlan(res.data.data); setFlow("UNSUB");}
                    /*if(res.data.responseCode===202) // Already Subscribed
                    {
                        setFlowLoading(false);
                        if(res.data.status===1) { //success
                            localStorage.setItem("token", res.data.data.accessToken);
                        window.location.href ="/home";
                        }else if(res.data.status===2) setSubMsg(msgLowbalance);
                        else setSubMsg(msgInprocess);
                    
                        setFlow("SUCCESS");
                    } else{ setFlowLoading(false);setFlow("PACK");} */
                }
            }).catch((err) => {
                console.log(err);
                setFlowLoading(false);
            });
        } 
            
    }, []);  
    /*
    const checkStatus = () =>{
            console.log("phone="+phone); 
            if (phone) {
                setFlowLoading(true); 
                subApi({action:0,ani: phone,serviceId:serviceId}).then((res) => {
                    if(res.data.data!==null && res.data.data!==undefined)
                    {
                        if(res.data.responseCode===202) // Already Subscribed
                        {
                            setFlowLoading(false);                            
                            if(res.data.status===1) { //success
                                localStorage.setItem("token", res.data.data.accessToken);
                               window.location.href ="/home";
                            }else if(res.data.status===2) setSubMsg(msgLowbalance);
                            else setSubMsg(msgInprocess);
                            setFlow("SUCCESS");

                        }else setFlowLoading(false);
                    } else setFlowLoading(false);
                }).catch((err) => {
                    console.log(err);
                    setFlowLoading(false);
                });
            }else setFlowLoading(false);  
        }
      */   
    const sendOtp = async() => {
        console.log('phone='+phone);
        setMessage({message: "",error: false});       
        setIsActive(false);
        if(phone && phone.length>=8)
        {
            var nm=phone;if(nm.length<=10)nm=countryCode+nm
            setPopupLoader(true);
            await subApi({action:3,serviceId:serviceId,ani: nm}).then((res) => { 
            //await subApi({action:0,ani: nm,serviceId:serviceId}).then((res) => {     
                if(res.status===200)
                { 
                    setIsActive(true);
                    setOtpId(res.data.data);
                    /*
                    if(res.data.responseCode===202) // Already Subscribed
                    {
                        setFlow("SUCCESS");
                        if(res.data.status===1) { //success
                            localStorage.setItem("token", res.data.data.accessToken);
                           window.location.href ="/home";
                         }else if(res.data.status===2) setSubMsg(msgLowbalance);
                        else setSubMsg(msgInprocess);

                    }else {setFlow("OTPCONFIRM");}
                    */
                }               
                setPopupLoader(false);
            }).catch((err) => {
                console.log(err);
                //setFlow("PACK");
                setMessage({message: err.message, error: true });
                setPopupLoader(false);
            });
        }
        else if(phone && phone.length>0){setMessage({message: "Please enter a valid number",error: true})}
        else{setMessage({message: "Please enter a number",error: true})}
       
       // navigate('/profile');
      };
    
      const confirmOtp = async() => {
        setMessage({message: "",error: false});     
        if(otp!=null && otp.length===4)
        {            
            var nm=phone;if(nm.length<10)nm=countryCode+nm
            setLoading(true);
            await subApi({action:4,serviceId:serviceId,ani: nm,otpId:otpId,otp:otp}).then((res) => {                    
                if(res.status===200)
                { 
                    localStorage.setItem("ugAlias",nm);
                    localStorage.setItem("token", res.data.data.accessToken);
                    window.location.href ="/home";
                    /*
                    if(res.data.responseCode===202) // already subscribed 
                    {
                        setFlow("SUCCESS");
                        if(res.data.status===1) { //success
                            localStorage.setItem("token", res.data.data.accessToken);
                            window.location.href ="/home";
                        }else if(res.data.status===2) setSubMsg(msgLowbalance);
                        else setSubMsg(msgInprocess);
                    }
                    else
                    {
                        localStorage.setItem("ugAlias",nm);
                        setOtpId(res.data.data);
                        setFlow("PACK");
                    }   
                    */                 
                }                
                else {setMessage({message: res.data.message,error: true})}
            }).catch((err) => {
                setMessage({message: err.message, error: true});
            }).finally(() => setLoading(false))
        }
        else{setMessage({ message:"OTP is not valid",error: true });}
      }   
    
    const subscribe = async() => {
        setPopup(false);setPopupLoader(true);
        var nm=0;
        if(phone)
        {
            nm=phone;
            if(nm.length<10)nm=countryCode+nm;
        }
        await subApi({action:1,serviceId:serviceId,planId:plan,ani:nm,mode:'WAP',otpId:otpId}).then((res) => { 
            setPopupLoader(false);
            setMessage({message:msgInprocess,error: false});
            setSubStatus(102);setPopup(true); 
            /* if(res.data.data!==null && res.data.data!==undefined)
                {   
                    if(res.data.responseCode===202 || res.data.responseCode===200) // already sub
                    {
                        setFlowLoading(false);                        
                        if(res.data.status===1) { //success
                            localStorage.setItem("token", res.data.data.accessToken);
                           window.location.href ="/home";
                        }else if(res.data.status===2) setSubMsg(msgLowbalance);
                        else setSubMsg(msgInprocess);

                        setFlow("SUCCESS");
                    }
                    else setFlow("SUCCESS");
                }else setFlow("SUCCESS");
                */
        }).catch((err) => {
            console.log(err); 
            setPopupLoader(false);           
            setMessage({message: err.message,error: true});
            setSubStatus(102);setPopup(true); 
        });
      };
    const unsub = async(insput) => {
        setPopup(false);
            setPopupLoader(true);
            await unsubApi({action:2,serviceId:serviceId,mode:'WAP'}).then((res) => {
                setPopupLoader(false);
                setMessage({message: "You are successfully unsubscribed from the servce.",error: false});
                setSubStatus(102);setPopup(true);
            }).catch((err) => {
                console.log(err);
                setPopupLoader(false);
                setMessage({message: err.message,error: true});
                setSubStatus(102);setPopup(true);
            })
          
    };
    const logout = async(insput) => {
        setPopup(false);
        setPopupLoader(true);
        await unsubApi({action:11,serviceId:serviceId,mode:'WAP'}).then((res) => {
            setPopupLoader(false);
            setPopup(false);localStorage.clear();
            window.location.href="/login";
        }).catch((err) => {
            console.log(err);
            setPopupLoader(false);
            setMessage({message: err.message,error: true});
            setSubStatus(102);setPopup(true);
        })
          
    };

    const handleNumberChange = async(event) =>{
        setIsActive(false);
        setMessage({message: "",error: false});   
        const input = event.target.value;
        if(input.length<11)setPhone(input);
        setButtonDisabled(input.length <8);
        if(otp.length >=4 && input.length>=8)
            setButtonLoginDisabled(false);
        else
            setButtonLoginDisabled(true);
    } 
    const handleOtpChange = async(event) =>{
        setMessage({message: "",error: false});   
        const input = event.target.value;
        if(input.length<5)setOtp(input);
        //console.log(phone+"::"+phone.length);
        if(input.length >=4 && phone.length>=8)
            setButtonLoginDisabled(false);
        else
            setButtonLoginDisabled(true);
    }  
    const handleRadioChange = async(input) =>{
        setPlan(input);
    }  
    const handleSubChange = async(input) =>{
        setSubOption(input);
    }    
    const handleSubOptionClick = async() => {
        if(subOption==2){setPlan(3);}
        else {setPlan(1);}
        setFlow("PACK");
    }
    const cancel = async(input) => {
        setMessage({message: "",error: false});
        setPhone('');
        setFlow(input);
    }
    const handleNumInputsChange = (numInputs) => {
        setOtp(numInputs);
        setButtonDisabled(numInputs.length !== 4 || isNaN(numInputs));
    }
    const redirectTo = async(input) => {
        if(input==="/home"){//checkStatus();
         setFlow("SUCCESS");}
        else if(input==="/main"){setPopup(false);navigate("/home");}
        else if(input==="/cancel"){setPopup(false);}
        else if(input==="/logout"){logout();}
        else navigate(input);
      };



    return (  
        flowLoading? <Loader />
        :<>     
        <div className='home'>
            <div className="maine-div">
                <div className="container-fluid box-wrapper login">               
                    <div className="login-header pb-4">
                        <div className="box-wrapper mx-auto text-center position-relative"> 
                            <span className="modal-level-title game-title">
                            Dive into the world of YoGamez! More than 1,000 games await you for an immersive and fun experience 🌟. Climb the rankings 📈 and be among the top 10 to receive exclusive rewards 🏆. play without limits and aim for the top of the leaderboard 🔝!
                            </span>
                        </div>
                    </div>
                    <div className="login-info">
                        <div className="login-thumbnail3">
                            <img src="/images/login_img_new.png" alt="YoGamez" />
                        </div>

                        { flow==="PACK" ? (
                        <> 
                            <h3 className="login-title mt-3 text-center">Welcome to YoGamez</h3> 
                            <h3 className="header-title-green mb-3 mt-3 text-center">Select subscription pack</h3>                        
                            <div className="text-center radio">
                                <label>
                                    <input type="radio" id="rd1" value="1" checked={plan === 1} onChange={() => handleRadioChange(1)} />
                                    2.02 ZWG/Day
                                </label><br/>
                                <label>
                                    <input type="radio" id="rd2" value="2" checked={plan === 2} onChange={() => handleRadioChange(2)} />
                                    8.08 ZWG/Week
                                </label><br/>
                                <label>
                                    <input type="radio" id="rd2" value="3" checked={plan === 3} onChange={() => handleRadioChange(3)} />
                                    24.25 ZWG/Month
                                </label>
                            </div>
                            <div className="text-center phone-info">
                                {loading ? <Loader />:<>
                                    <button className="btn btn-primary btn-pm-custom" type="button" onClick={()=>{setSubStatus(101);setPopup(true);}}>Subscribe Now</button>
                                    <div className="popupDiv col-12">  
                                    <button className="btn btn-primary btn-pm-red" type="button" onClick={()=>navigate('/home')}>CANCEL</button>                             
                                    &nbsp;&nbsp;<button className="btn btn-primary btn-pm-green" type="button" onClick={()=>{setSubStatus(104);setPopup(true);}}>LOGOUT</button>                                        
                                    </div>
                                </>
                                }
                            </div>
                        </> 
                        ): flow === "OTPCONFIRM" ?(
                        <>
                             <h3 className="login-title mb-3 mt-3 text-center">Enter OTP</h3>
                             <div className="phone-info">
                                <div className="otp_section">               
                                    <OtpInput
                                        value={otp}
                                        numInputs={4}
                                        renderInput={(props, index) => (
                                            <input   {...props}  type="tel" inputMode="numeric" />
                                        )}
                                        inputStyle="form-control form-otp"
                                        onChange={handleNumInputsChange}
                                    />
                                </div>
                                {message.message && <div className="mb-3"><p className={`alert alert-${message.error ? 'danger' : 'success'}`}>{message.message}</p> </div>}
                                {loading ? <Loader />:<button className="btn btn-primary btn-pm-custom" type="button" onClick={confirmOtp} disabled={ButtonDisabled}>Confirm</button>}
                                <div className="resend_otp"><a className="send_otp_link" onClick={() => {cancel('')}}> &lt;&lt;&nbsp;Back</a></div>
                            </div>
                        </>
                         ):flow === "CONFIRM" ?(
                            <>
                                 <h3 className="login-title mb-3 mt-3 text-center">You are about to register for the YoGamez service for <span className="span-bold">{price[plan]}</span> automatically renewable</h3>
                                 <h3 className="login-title mb-3 mt-3 text-center">Are you sure you want to continue?</h3>
                                 {message.message && <div className="mb-3"><p className={`alert alert-${message.error ? 'danger' : 'success'}`}>{message.message}</p> </div>}
                                 {loading ? <Loader />:<button className="btn btn-primary btn-pm-green" type="button" onClick={subscribe} >YES</button>}
                                 <button className="btn btn-primary btn-pm-red" type="button" onClick={()=>setFlow('')}>NO</button>
                                
                            </>
                        ):flow === "UNSUB" ?(
                            <>
                                 <h3 className="login-title mb-3 mt-3 text-center">You are subscribed for <br/><span className="span-bold">{price[plan]}</span> pack.<br/> To unsubscribe click on unsubscribe button.</h3>
                                 <button className="btn btn-primary btn-pm-custom" type="button" onClick={()=>{setSubStatus(103);setPopup(true);}}>Unsubscribe</button>
                                 <div className="popupDiv col-12">  
                                 <button className="btn btn-primary btn-pm-red" type="button" onClick={()=>navigate('/home')}>CANCEL</button>                             
                                 &nbsp;&nbsp;<button className="btn btn-primary btn-pm-green" type="button" onClick={()=>{setSubStatus(104);setPopup(true);}}>LOGOUT</button>                                        
                                 </div>
                            </>
                        ):flow === "SUCCESS" ?(
                        <>
                            {subMsg && <h3 className="login-title-green mb-3 mt-3 text-center">{subMsg}</h3>}
                            <h3 className="login-title mb-3 mt-3 text-center">To access the service, click on below 'Click Here' button</h3>
                            {loading ? <Loader />:<>
                            <button className="btn btn-primary btn-pm-custom" type="button" onClick={() => {redirectTo('/home')}}>Click Here</button> 
                            <div className="resend_otp"><a className="send_otp_link" onClick={() => {cancel('')}}> &lt;&lt;&nbsp;Back</a></div>   
                            </>}                     
                        
                        </>                        
                        ): (
                            <>    
                                <h3 className="login-title mt-3 text-center">Welcome to YoGamez</h3>  
                                <h3 className="login-title mt-1 text-center">Enter your number to login on service</h3>                              
                                <div className="phone-input">  
                                    <div className="has-validation input-group">
                                            <div className="dialing-code">
                                                <img src={"https://flagcdn.com/"+flag+".svg"} width="24" alt="Cameroon" />
                                                <span>+{countryCode}</span>
                                            </div>
                                            <input                                    
                                                className="form-control form-mobile-no" 
                                                type="number" 
                                                inputMode="numeric" 
                                                value={phone?phone:''}
                                                onChange={handleNumberChange}
                                                placeholder="Enter Mobile Number"
                                            />                                           
                                    </div> <br/>   
                                    <div className="has-validation input-group">  
                                            <div className="dialing-otp">
                                                {isActive?
                                                <span className="btn btn-pm-span">{seconds}s</span>:
                                                <button className="btn btn-pm-otp" type="button" onClick={sendOtp} disabled={ButtonDisabled}>Get Code</button>}                                               
                                            </div>                                             
                                            <input                                    
                                                className="form-control form-mobile-no" 
                                                type="number" 
                                                inputMode="numeric" 
                                                value={otp}
                                                onChange={handleOtpChange}
                                                placeholder="Enter verification code"
                                            />   
                                                                                
                                    </div>

                                    {message.message && <div className="mb-3"><p className={`alert alert-${message.error ? 'danger' : 'success'}`}>{message.message}</p> </div>}                              
                                    {loading ? <Loader />:<button className="btn btn-primary btn-pm-custom" type="button" onClick={confirmOtp} disabled={ButtonLoginDisabled}>Login</button>}
                                </div>
                            </>
                        )}
                    </div>                    
                </div>
            </div>
        </div>
        {popup && <PopupSub subStatus={subStatus} plan={price[plan]} redirectTo={redirectTo} sub={subscribe} unsub={unsub} message={message} />}
        {popupLoader && <Popup />}
        </>
    )
}

export default Ecoz